module.exports = __webpack_public_path__ + "img/th_get.8b3e16b.png";